import { contactRoleLabelForDisplay } from "./contactRoleLabel";

const ALUMNO_FILTER_ROLES = new Set(["alumno", "usuario", "estudiante"]);

/**
 * @typedef {"all" | "alumno" | "instructor" | "director" | "staff"} MessagingRoleFilter
 */

/**
 * Role used for sidebar filters (platform role wins over course enrollment label).
 * @param {object | null | undefined} contacto
 * @returns {string}
 */
export function resolveMessagingFilterRole(contacto) {
  const rawRole = String(contactRoleLabelForDisplay(contacto) || "").trim().toLowerCase();
  return ALUMNO_FILTER_ROLES.has(rawRole) ? "alumno" : rawRole;
}

/**
 * @param {Array<object>} contactos
 * @param {MessagingRoleFilter} filter
 * @returns {Array<object>}
 */
export function filterMessagingContactsByRole(contactos, filter) {
  const list = Array.isArray(contactos) ? contactos : [];
  const normalizedFilter = String(filter || "all").toLowerCase();
  if (normalizedFilter === "all") {
    return list;
  }
  return list.filter((c) => {
    const rol = resolveMessagingFilterRole(c);
    if (normalizedFilter === "alumno") {
      return rol === "alumno";
    }
    if (normalizedFilter === "instructor") {
      return rol === "instructor";
    }
    if (normalizedFilter === "director") {
      return rol === "director";
    }
    if (normalizedFilter === "staff") {
      return rol === "director" || rol === "instructor";
    }
    return false;
  });
}
